<template>
    <div class="flex flex-col items-center gap-4 text-center">
        <div class="flex flex-col gap-2 max-w-xl">
            <p class="body-small text-ink-muted">{{ t("reflections.team.howItWorks.intro") }}</p>
        </div>

        <ol class="flex flex-col gap-4 w-full max-w-xl text-left">
            <li v-for="step in steps" :key="step.n" class="flex items-start gap-3">
                <span class="flex items-center justify-center w-7 h-7 shrink-0 rounded-full bg-surface-sunken body-small-bold text-ink-muted">
                    {{ step.n }}
                </span>
                <p class="body-small text-ink-muted">
                    <span class="body-small-bold text-ink">{{ step.title }}</span>
                    {{ step.body }}
                </p>
            </li>
        </ol>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

// No `Launch` CTA: raters can't proactively give feedback — they respond to
// invites teammates send, which appear as rows on the tab itself.
const steps = computed(() => [
    { n: 1, title: t("reflections.team.howItWorks.requestsTitle"), body: t("reflections.team.howItWorks.requestsBody") },
    { n: 2, title: t("reflections.team.howItWorks.answerTitle"), body: t("reflections.team.howItWorks.answerBody") },
    { n: 3, title: t("reflections.team.howItWorks.confidentialTitle"), body: t("reflections.team.howItWorks.confidentialBody") },
]);
</script>
